var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyviolation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4682 18.2444L12.0378 2.31026C11.9311 2.12998 11.7793 1.9806 11.5973 1.87684C11.4153 1.77308 11.2095 1.71851 11 1.71851C10.7905 1.71851 10.5847 1.77308 10.4027 1.87684C10.2207 1.9806 10.0689 2.12998 9.96222 2.31026L0.531781 18.2444C0.408706 18.4527 0.34377 18.6901 0.34375 18.9319C0.34375 19.2898 0.485899 19.633 0.738927 19.886C0.991955 20.139 1.33513 20.2812 1.69297 20.2812H20.307C20.6649 20.2812 21.008 20.139 21.2611 19.886C21.5141 19.633 21.6562 19.2898 21.6562 18.9319C21.6562 18.6901 21.5913 18.4527 21.4682 18.2444Z",
    fill: "#47323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73389 18.9062L11 3.25659L20.262 18.9062H1.73389Z",
    fill: "#FAC437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5312C11.5695 17.5312 12.0312 17.0695 12.0312 16.5C12.0312 15.9305 11.5695 15.4688 11 15.4688C10.4305 15.4688 9.96875 15.9305 9.96875 16.5C9.96875 17.0695 10.4305 17.5312 11 17.5312Z",
    fill: "#47323B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 14.4375H10.3125L9.625 7.90625H12.375L11.6875 14.4375Z",
    fill: "#47323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyviolation);
export default __webpack_public_path__ + "static/media/safetyviolation.33cfc7ba79a67ad0e93f285b0c4b915d.svg";
export { ForwardRef as ReactComponent };